export default "__VITE_ASSET__DHYAqIL5__"